var map = {
	"./_black_green.styl": 1289,
	"./_black_grey.styl": 1290,
	"./_black_red.styl": 1291,
	"./_blue.styl": 1292,
	"./_default.styl": 1293,
	"./_grey_light.styl": 1294,
	"./_light_black.styl": 1295,
	"./_pink_light.styl": 1296,
	"./_purple_dark.styl": 1297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1288;


//////////////////
// WEBPACK FOOTER
// ../colorscheme !/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[sha512:hash:base64:7].css!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-colorsheme-res-resolver!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader ^\.\/_.*\.styl$
// module id = 1288
// module chunks = 4